import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02a80396"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = { class: "app__title mt-0" }
const _hoisted_3 = {
  cols: "12",
  class: "text-center document-title primary__color"
}
const _hoisted_4 = { class: "req" }
const _hoisted_5 = { class: "req" }
const _hoisted_6 = {
  cols: "12",
  class: "text-center document-title primary__color"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))
const _hoisted_8 = {
  cols: "12",
  class: "text-center document-title primary__color"
}
const _hoisted_9 = { class: "req" }
const _hoisted_10 = { class: "req" }
const _hoisted_11 = { class: "req" }
const _hoisted_12 = { class: "req" }
const _hoisted_13 = { class: "req" }
const _hoisted_14 = { class: "req" }
const _hoisted_15 = { class: "req" }
const _hoisted_16 = { class: "req" }
const _hoisted_17 = { for: "fileControl" }
const _hoisted_18 = { class: "fileName" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24,
          class: "app__header__title"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("program.events")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("abstract.abstractTitle")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { type: "flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          class: "form__container",
          ref: "formAbstract",
          model: _ctx.form,
          rules: _ctx.abstractFormProps,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("abstract.mainAuthor")), 1),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("abstract.fullName")), 1),
                _createVNode(_component_el_input, {
                  modelValue: $setup.registerAbstract.fullName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.registerAbstract.fullName) = $event)),
                  text: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("abstract.institution")), 1),
                _createVNode(_component_el_input, {
                  modelValue: $setup.registerAbstract.institution,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.registerAbstract.institution) = $event)),
                  text: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("abstract.coAuthors")), 1),
            _createVNode(_component_el_form_item, {
              cols: "12",
              md: "4",
              label: _ctx.$t('abstract.coName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.coAuthorName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.coAuthorName) = $event)),
                  text: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              cols: "12",
              md: "4",
              label: _ctx.$t('abstract.coLastName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.coAuthorLastName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.coAuthorLastName) = $event)),
                  text: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              cols: "12",
              md: "4",
              label: _ctx.$t('abstract.coCountry')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.coAuthorCountry,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.coAuthorCountry) = $event)),
                  text: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              cols: "12",
              md: "4",
              label: _ctx.$t('abstract.coCity')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.coAuthorCity,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.coAuthorCity) = $event)),
                  text: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.coauthors, (value, index) => {
              return (_openBlock(), _createBlock(_component_el_row, { key: index }, {
                default: _withCtx(() => [
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t("abstract.titleCoAuthores")) + _toDisplayString(index + 1) + ": " + _toDisplayString(value.name) + " " + _toDisplayString(value.lastName), 1)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            _createVNode(_component_el_row, {
              class: "margin_button",
              type: "flex",
              justify: "center",
              align: "middle"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { class: "text--center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "secondary__color__button",
                      icon: "el-icon-plus",
                      circle: "",
                      disabled: !$setup.validateFormCoAuthors,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.addCoAuthor()))
                    }, null, 8, ["disabled"])
                  ]),
                  _: 1
                }),
                ($setup.validateFormCoAuthors)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 24,
                      class: "text--center text-pd gray__base__colors"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _hoisted_7,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("abstract.validateFormCo")), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("abstract.abstract")), 1),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("abstract.title")), 1),
                _createVNode(_component_el_input, {
                  modelValue: $setup.registerAbstract.title,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.registerAbstract.title) = $event)),
                  text: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { "label-width": "auto" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("abstract.format")), 1),
                _createVNode(_component_el_input, {
                  modelValue: $setup.registerAbstract.format,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.registerAbstract.format) = $event)),
                  maxlength: "100",
                  "show-word-limit": "",
                  text: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { cols: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("abstract.summary")), 1),
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: $setup.registerAbstract.summary,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.registerAbstract.summary) = $event)),
                  maxlength: "250",
                  "show-word-limit": "",
                  rows: "12"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { cols: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("abstract.method")), 1),
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: $setup.registerAbstract.method,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.registerAbstract.method) = $event)),
                  maxlength: "500",
                  "show-word-limit": "",
                  rows: "12"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { cols: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("abstract.result")), 1),
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: $setup.registerAbstract.result,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.registerAbstract.result) = $event)),
                  maxlength: "500",
                  "show-word-limit": "",
                  rows: "12"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { cols: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("abstract.discussion")), 1),
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: $setup.registerAbstract.discussion,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.registerAbstract.discussion) = $event)),
                  maxlength: "250",
                  "show-word-limit": "",
                  rows: "12"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { cols: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("abstract.conclusion")), 1),
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: $setup.registerAbstract.conclusion,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.registerAbstract.conclusion) = $event)),
                  maxlength: "250",
                  "show-word-limit": "",
                  rows: "12"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { cols: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("abstract.bibliography")), 1),
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: $setup.registerAbstract.bibliography,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.registerAbstract.bibliography) = $event)),
                  maxlength: "250",
                  "show-word-limit": "",
                  rows: "12"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_alert, {
              class: "alert-size",
              title: "Info Alert",
              type: "info",
              "show-icon": "",
              effect: "dark"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("abstract.pdfInstructions")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "text--center" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "center",
                  align: "middle"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("input", {
                        class: "inputfile secondary__color__button",
                        type: "file",
                        id: "fileControl",
                        accept: "application/pdf",
                        ref: "savedFile",
                        "data-buttonName": "btn-primary",
                        onChange: _cache[15] || (_cache[15] = ($event: any) => ($setup.setFileAbst(_ctx.$refs.savedFile.files[0])))
                      }, null, 544),
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("abstract.fileDefault")), 1),
                      _createElementVNode("span", _hoisted_18, _toDisplayString($setup.detailsAreVisible ? $setup.titleFile : _ctx.$t("abstract.nameFileDefault")), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(_component_el_row, {
          type: "flex",
          justify: "center",
          align: "middle",
          class: "abstract_to"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              cols: "12",
              class: "text--center margin_button"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  block: "",
                  color: "accent",
                  class: "secondary__color__button",
                  disabled: !$setup.validateForm,
                  onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.saved()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("abstract.send")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            (!$setup.validateForm)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  span: 24,
                  class: "text--center text-pd gray__base__color"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("abstract.validateForm")), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}